<template>
    <div class="page">
        <div class="logo-box">
            <span class="text">欢迎使用，</span>
            <span class="text">居延旅行社管理后台</span>
            <div class="line"></div>
        </div>
        <van-form class="form" @submit="onSubmit" validate-trigger="onSubmit">
            <van-field
                    v-model="phoneNumber"
                    type="tel"
                    name="手机号"
                    label=""
                    placeholder="请输入手机号码"
                    required
                    maxlength="11"
                    :rules="[{ required: true, message: '请输入手机号码' }]"
            >
                <template #left-icon>
                    <img class="icon" src="@/assets/images/user/ic_phone.png">
                </template>
            </van-field>
            <van-field
                    v-model="loginPassword"
                    type="password"
                    name="密码"
                    label=""
                    placeholder="请输入密码"
                    required
                    maxlength="16"
                    :rules="[{ required: true, message: '请输入密码' }]"
            >
                <template #left-icon>
                    <img class="icon" src="@/assets/images/user/ic_pwd.png">
                </template>
            </van-field>
            <van-button class="btn" type="default" block round
                        color="#0079DD"
                        :loading="loading"
                        loading-text="登录中"
                        native-type="submit">登录
            </van-button>
        </van-form>
    </div>
</template>

<script>
    import {Form, Field, Button} from 'vant';

    export default {
        name: "login",
        components: {
            [Form.name]: Form,
            [Field.name]: Field,
            [Button.name]: Button
        },
        data() {
            return {
                phoneNumber: '',
                loginPassword: '',
                loading: false,
                redirect: undefined,
                otherQuery: {}
            };
        },
        watch: {
            $route: {
                handler: function (route) {
                    const query = route.query
                    if (query) {
                        this.redirect = query.redirect
                        this.otherQuery = this.getOtherQuery(query)
                    }
                },
                immediate: true
            }
        },
        created() {
        },
        methods: {
            onSubmit() {
                this.loading = true
                let options = {
                    phoneNumber: this.phoneNumber,
                    loginPassword: this.loginPassword
                }
                this.$store.dispatch('user/login', options)
                    .then(res => {
                        this.loading = false
                        this.$toast('登录成功')
                        this.$router.push({
                            path: this.redirect || '/index',
                            query: this.otherQuery
                        })
                    })
                    .catch(() => {
                        this.loading = false
                    })
            },
            getOtherQuery(query) {
                return Object.keys(query).reduce((acc, cur) => {
                    if (cur !== 'redirect') {
                        acc[cur] = query[cur]
                    }
                    return acc
                }, {})
            },
        }
    }
</script>

<style scoped lang="scss">
    .page {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: white;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
    }

    .logo-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 20px;
        box-sizing: border-box;
        margin-top: 80px;

        .text {
            font-size: 24px;
            color: #333333;
            margin-top: 10px;
            font-weight: bold;
        }

        .line {
            width: 40px;
            height: 3px;
            background-color: #0079DD;
            margin-top: 20px;
        }
    }

    .form {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        box-sizing: border-box;
        margin-top: 20px;

        .icon {
            width: 18px;
            height: 18px;
            margin-top: 3px;
        }
    }

    .btn {
        width: 100%;
        margin-top: 60px;
    }
</style>
